import React, { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styles from './MenuItem.module.scss'
import { Text } from 'components/Text'
import cx from 'classnames'

type MenuItemProps = {
  path: string
  text: string
}

export const MenuItem: FC<MenuItemProps> = (props) => {
  const location = useLocation()

  const classes = cx({
    [styles.isActive]: props.path === location.pathname,
    [styles.menuItem]: styles.menuItem,
  })

  return (
    <Link to={props.path} className={classes}>
      <Text align="right" weight="strong" className={styles.menuText} component="span">
        {props.text}
      </Text>
    </Link>
  )
}

MenuItem.displayName = 'MenuItem'
